import React from "react";

const Error404 = (): JSX.Element => {
  return (
    <div>
      <h1>Error 404</h1>
    </div>
  );
};

export default Error404;
